import { render, staticRenderFns } from "./StudentCategories.vue?vue&type=template&id=19f5235a"
import script from "./StudentCategories.vue?vue&type=script&lang=ts"
export * from "./StudentCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports